import { type Profile } from "../../profile/profile.ts"

import * as UI from "@iyk/ui"

import { appConfig } from "../../../app-config.ts"
import { GlobalRoutes } from "../../../react-router/routes.ts"
import { useScrollVisibility } from "../../profile/ui/use-scroll-visibility.tsx"
import { UserMenu } from "../../profile/ui/user-menu.tsx"
import { Link } from "../../ui/link.tsx"
import type { Shop } from "../shop.ts"

export const Header = ({ user, cart }: { user?: Profile.User; cart: Shop.Cart | null }) => {
  const { headerRef, isHidden, isScrolled } = useScrollVisibility()

  return (
    <header ref={headerRef} className={classForHeader({ isHidden, isScrolled })}>
      <Link to={GlobalRoutes.shop.landing} className="content-center">
        <img
          src={appConfig.assets.images.logo.url}
          style={{ width: `${appConfig.assets.images.logo.width}px` }}
          alt={`${appConfig.artist.name} logo`}
        />
      </Link>
      <div className="flex items-center gap-4">
        {cart && <CartButton quantity={cart.totalQuantity} />}
        {user ? (
          <UserMenu username={user.username} userId={user.id} totalProofs={user.totalProofs} />
        ) : (
          <Link
            to={GlobalRoutes.login({ returnTo: GlobalRoutes.profile })}
            className={UI.classForButton({ size: "sm", kind: "shaded" })}
          >
            Login
          </Link>
        )}
      </div>
    </header>
  )
}

const CartButton = ({ quantity }: { quantity: number }) => {
  return (
    <Link viewTransition to={GlobalRoutes.shop.cart} className="relative">
      <UI.Icon.Bag className="size-6" />
      <div className="absolute -top-1 -right-1 text-xs">{quantity}</div>
    </Link>
  )
}

const classForHeader = UI.cva(
  [
    "text-gray-12 sticky",
    "z-30 top-0 left-0 w-full h-[60px] p-4",
    "flex item-center justify-between",
    "transition-all duration-300 ease-in-out"
  ],
  {
    variants: {
      isHidden: {
        true: "top-[calc(60px*-1)]"
      },
      isScrolled: {
        true: "backdrop-blur-md bg-black/[85%]"
      }
    }
  }
)
